<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-descriptions title="" :column="7" :colon="false">
        <el-descriptions-item label="统计于：">{{exceptionObj.time}}</el-descriptions-item>
        <el-descriptions-item label="订单："><span class="c-danger">{{exceptionObj.allOrderCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="收款单："><span class="c-danger">{{exceptionObj.shoukuandanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="付款单："><span class="c-danger">{{exceptionObj.fukuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="退款单："><span class="c-danger">{{exceptionObj.tuikuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="用户信息："><span class="c-danger">{{exceptionObj.yonghuCount}}</span>个推送失败</el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单类型：" prop="orderType">
            <el-select v-model="query.orderType" placeholder="请选择" clearable size="small">
              <el-option label="订货订单" :value="1"></el-option>
              <el-option label="积分订单" :value="2"></el-option>
              <el-option label="秒杀订单" :value="3"></el-option>
              <el-option label="换货订单" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号：" prop="ordernum">
            <el-input v-model="query.ordernum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="推送状态：">
            <el-select v-model="query.isSendedYongyou" placeholder="请选择" clearable size="small">
              <el-option label="推送成功" :value="1"></el-option>
              <el-option label="推送失败" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="推送时间范围：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item> -->
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="primary" @click="handleAllPush" size="mini">推送全部订单到聚水潭</el-button>
            <!-- <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-table v-loading="listLoading" :data="list " @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="订单类型" prop="type" align="center" fixed>
          <template slot-scope="{row}">
            {{row.type | setType}}
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="orderNum" align="center" fixed>
        </el-table-column>
        <el-table-column label="下单人" prop="name" align="center">
        </el-table-column>
        <el-table-column label="手机号" prop="phone" align="center">
        </el-table-column>
        <el-table-column label="订单创建时间" prop="createdTime" align="center" sortable width="200">
        </el-table-column>
        <el-table-column label="订单状态" prop="state" align="center">
          <template slot-scope="{row}">
            {{row.state | setState}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="成" prop="sendTime" align="center" sortable width="200">
        </el-table-column> -->
        <el-table-column label="推送成功时间" prop="sendTime" align="center" sortable width="200">
        </el-table-column>
        <el-table-column label="推送状态" prop="isSendedYongyou" align="center" width="150">
          <template slot-scope="{row}">
            <el-button type="success" plain size="mini" v-if="row.isSendedYongyou">推送成功</el-button>
            <el-button type="danger" plain size="mini" v-else>推送失败</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <el-button type="text" @click="handlePush(0,row)">推送订单</el-button>
            <!-- <el-button type="text" @click="handleDel(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <order-show ref="orderShow" @created="doQueryList({})" />
  </div>
</template>

<script>
import orderShow from './show'
import goodsOrderApi from '@/api/order/goodsOrder'
import sysToolsApi from '@/api/sys/tools'
import Pagination from '@/components/Pagination'
import homeStatisticsApi from '@/api/home'
import { Subtr, formatDateStr } from '@/utils/index'
export default {
  components: {
    Pagination,
    orderShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      exceptionObj: {}
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getException()
  },
  filters: {
    setState(i) {
      const Maps = new Map([
        [0, '已取消'],
        [1, '待支付'],
        [2, '待发货'],
        [3, '已发货'],
        [4, '已完成'],
        [-1, '已失效']
      ])
      return Maps.get(i)
    },
    setType(i) {
      const Maps = new Map([
        [1, '订货订单'],
        [2, '积分订单'],
        [3, '秒杀订单'],
        [4, '换货订单']
      ])
      return Maps.get(i)
    }
  },
  methods: {
    handleAllPush() {
      sysToolsApi.sendOrderToYongYouAll().then(res => {
        this.$message.success('操作成功')
        this.doQueryList({})
      })
    },
    getException() {
      homeStatisticsApi.getHomeException().then(res => {
        let { dinghuoCount, miaoshaCount, jifenCount } = res.data;
        let count = Subtr(Subtr(dinghuoCount, -miaoshaCount), -jifenCount)
        res.data.allOrderCount = count
        res.data.time = formatDateStr(new Date())
        this.exceptionObj = res.data;
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // canLookGoodsPrice: 1,
        // canStudyCourse: 1
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      this.listLoading = true
      return goodsOrderApi.getSnedOrderList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 推送
    async handlePush(type, row) {
      // console.log('row: ',row);
      if (type) {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择订单')
          return
        }
        // console.log('command: ', command, this.selectItems);
        let ids = this.selectItems.map(row => row.id)
        let txt = ""
      } else {
        let res = await sysToolsApi.sendOrder({ orderid: row.id })
        let data = res.data
        if (data.state === 1) {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        } else {
          this.$common.showMsg('error', data.returnParameter)
        }
      }
    },
    /**
     * 打开详情表单
     */
    handleShow(row) {
      this.$refs.orderShow.handleCreate(row)
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
</style>
